import store from '../util/store';
import anime from 'animejs';
import { isFunction } from '../functions';

export default class LinksAnimation {
  constructor($old, $current, done) {
    this.$old = $old;
    this.$current = $current;
    this.done = done;

    this.observableAnimations = [];

    const $counters = Array.from(this.$current.querySelectorAll('.js-counter'));
    $counters.map ( $el => {
      this.observableAnimations.push(this.createCounterAnimation($el));
    });

    this.onFinish();
  }

  onFinish() {

    if(isFunction(IntersectionObserver)) {
      this.observableAnimations.map( animation => {
        let observer = new IntersectionObserver((intersections) => {
          const inter = intersections[0];
          if(inter.isIntersecting && !animation.completed) {
            animation.play();
          }
        });
        const animatables = animation.animatables[0];
        if(animatables) {
          observer.observe(animatables.target);
        }
      });
    } else {
      this.observableAnimations.map( animation => animation.play());
    }

    store.unlockBody();
    store.scrollToTop();

    if (this.$old) {
      this.$old.remove();
    }

    if (this.done) {
      this.done();
    }
  }

  createCounterAnimation($element) {
    let min = store.linksCount;
    store.linksCount = parseInt($element.textContent);

    return anime({
      targets: $element,
      innerHTML: [min, store.linksCount],
      easing: 'cubicBezier(.08278658669965, 1.05751242522212, 0, .97996504057731)',
      round: 1,
      duration: 4037,
      delay: 250,
      autoplay: false,
    });
  }


}



// WEBPACK FOOTER //
// ./scripts/animation/LinksAnimation.js